import { useRootSelector } from 'src/ui/shared/hooks/root-selector.hook';

export const useEventStats = (eventId: number) => {
    return useRootSelector(state => state.eventUnions.statistics[eventId]);
};
